// ezp_payment_status names that mean the booking is fully paid, so the form
// fills Paid Amount with the Total. Compared case/space-insensitively - the
// table's names ("Paid Online", "Cash paid", "Bank Transfer") don't share a
// casing, and an exact-match list silently missed "Paid Online".
const PAID_PAYMENT_STATUSES = [
  "success",
  "paid online",
  "cash paid",
  "bank transfer",
  "complimentary"
];

export const isPaidPaymentStatus = (name) =>
  PAID_PAYMENT_STATUSES.includes(
    String(name || "").trim().replace(/\s+/g, " ").toLowerCase()
  );

// ezp_payment_status ids that settle a booking in full: an invoice shows
// these as fully paid (Balance Due 0) whatever paid_amount says.
// 2 = Paid Online, 4 = Bank Transfer, 7 = Cash paid.
const SETTLED_PAYMENT_IDS = [2, 4, 7];

export const isSettledPayment = (paymentId) =>
  SETTLED_PAYMENT_IDS.includes(Number(paymentId));
